import { useEffect } from 'react';
import Header from "./layout/Header/Header"
import Home from "./container/Home"
import Footer from "./layout/Footer/Footer"
import "swiper/swiper-bundle.min.css";
import "./assets/css/style.css";
import "./assets/css/faq.css";
import "./assets/css/roadMap.css";
import "./assets/css/team.css";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import mainLogo from './assets/images/others/logo.png';
import { AnimatePresence } from "framer-motion";


function App() {
  useEffect(() => {
    window.onload = function () {
      document.querySelector('.loader-wrapper').classList.add('d-none')
    };
    console.clear();
  }, [])

  return (
    <AnimatePresence>
      <Header />
      <Home />
      <Footer />
      <GoToTop />
      <Loader />
    </AnimatePresence>
  );
}

// Website Loader
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="fixed-loading-wrapper">
        <div className="loader-wrapp">
          <div className="loader-logo">
            <img src={mainLogo} alt="" />
          </div>
          <div className="loader"></div>
        </div>
      </div>
    </div>
  )
};

// Go To Top
const GoToTop = () => {
  useEffect(() => {
    window.onscroll = function () {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
      let btn = document.getElementById('scrollToTop');
      if (btn) {
        if (pageOffset > 450) {
          btn.classList.add('show-top')
        } else {
          btn.classList.remove('show-top')
        }
      }
    }
  }, []);
  // 
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  return (
    <div onClick={goToTop} className="go-to-top" id="scrollToTop">
      <ArrowUpwardIcon />
    </div>
  )
}

export default App;
